<div class="min-vh-100 d-flex justify-content-center align-items-center bg-light">
  <div class="card shadow-lg p-4" style="max-width: 400px; width: 100%; border-radius: 1rem;">
    <div class="text-center mb-4">
      <h3 class="fw-bold text-primary">Recuperar Contraseña</h3>
      <p class="text-muted small">Te enviaremos instrucciones a tu correo</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="recuperar()">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-envelope"></i>
          </span>
          <input
            type="email"
            id="email"
            class="form-control"
            formControlName="email"
            placeholder="ejemplo@correo.com"
            [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
          />
          <div class="invalid-feedback">Email inválido</div>
        </div>
      </div>

      <div *ngIf="mensaje" class="alert alert-success small py-2">{{ mensaje }}</div>
      <div *ngIf="error" class="alert alert-danger small py-2">{{ error }}</div>

      <button
        type="submit"
        class="btn btn-primary w-100 mb-3"
        [disabled]="form.invalid || loading"
      >
        {{ loading ? 'Enviando...' : 'Enviar instrucciones' }}
      </button>

      <div class="text-center">
        <a style="cursor: pointer;" (click)="volverLogin()" class="small text-decoration-none">
          <i class="fa-solid fa-arrow-left"></i> Volver al login
        </a>
      </div>
    </form>
  </div>
</div>
